import { render } from "./ScmWidget.vue?vue&type=template&id=5e9fce24&scoped=true"
import script from "./ScmWidget.vue?vue&type=script&lang=js"
export * from "./ScmWidget.vue?vue&type=script&lang=js"

import "./ScmWidget.vue?vue&type=style&index=0&id=5e9fce24&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9fce24"]])

export default __exports__